import { render, staticRenderFns } from "./ReviewInformation.vue?vue&type=template&id=0c242453&scoped=true"
import script from "./ReviewInformation.vue?vue&type=script&lang=js"
export * from "./ReviewInformation.vue?vue&type=script&lang=js"
import style0 from "./ReviewInformation.vue?vue&type=style&index=0&id=0c242453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c242453",
  null
  
)

export default component.exports